import React from 'react';
import { APP_NAME } from '../config/brand';

export const BRAND_NAVY = '#202124';
export const BRAND_ORANGE = '#e16711';
export const BRAND_NAME = APP_NAME;
const SIZES = { sm: 23, md: 29, lg: 36, xl: 48 };

// MekandaPro adaptation of the Mekanda wordmark, served locally.
export const LogoWordmark = ({ size = 29, className = '' }) => (
  <img src={`${process.env.PUBLIC_URL || ''}/brand/mekanda-pro-logo.png`}
    alt="mekanda.pro" width="1905" height="825" draggable="false"
    className={`brand-original-logo ${className}`}
    style={{ width: size * 4.6, maxWidth: '100%', height: 'auto', display: 'block', objectFit: 'contain' }} />
);
export const LogoMark = ({ size = 28, className = '' }) => <LogoWordmark size={size} className={className} />;
const Logo = ({ size = 'md', className = '' }) => (
  <LogoWordmark size={typeof size === 'number' ? size : SIZES[size] || SIZES.md} className={className} />
);
export default Logo;
